import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const BasketIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 30, height = 30, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.33325 9.33309H26.6666M13.3333 14.6664V22.6664M18.6666 14.6664V22.6664M6.66659 9.33309L7.99992 25.3331C7.99992 26.0403 8.28087 26.7186 8.78097 27.2187C9.28106 27.7188 9.95934 27.9998 10.6666 27.9998H21.3333C22.0405 27.9998 22.7188 27.7188 23.2189 27.2187C23.719 26.7186 23.9999 26.0403 23.9999 25.3331L25.3333 9.33309M11.9999 9.33309V5.33309C11.9999 4.97947 12.1404 4.64033 12.3904 4.39028C12.6405 4.14023 12.9796 3.99976 13.3333 3.99976H18.6666C19.0202 3.99976 19.3593 4.14023 19.6094 4.39028C19.8594 4.64033 19.9999 4.97947 19.9999 5.33309V9.33309"
          stroke="white"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
